<template>
  <div>
    <p v-html="formatedText"></p>
    <span v-show="text.length > maxChars">
      <a :href="link" id="readmore" v-show="!isReadMore" @click.prevent="triggerReadMore(true)">{{ moreStr }}</a>
      <a :href="link" id="readmore" v-show="isReadMore" @click.prevent="triggerReadMore(false)">{{ lessStr }}</a>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    moreStr: {
      type: String,
      default: 'read more',
    },
    lessStr: {
      type: String,
      default: 'read less',
    },
    text: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: '#',
    },
    maxChars: {
      type: Number,
      default: 450,
    },
  },
  data() {
    return {
      isReadMore: false,
    }
  },
  computed: {
    formatedText() {
      let text = this.text

      if (!this.isReadMore && this.text.length > this.maxChars) {
        text = `${text.substring(0, this.maxChars)}...`
      }

      return text
    },
  },
  methods: {
    triggerReadMore(b) {
      if (this.lessStr !== null || this.lessStr !== '') {
        this.isReadMore = b
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ReadMore.vue